(ns common.sync-progress)

(def BASE 1)
(def DEALFLOW 2)
(def DECISIONS 3)
(def FUNDRAISING 4)
(def SALES 5)
(def CONTACTS 6)
(def OPTIONS-TASKS 7)
(def COMPANIES 8)
(def HOLDING-AND-OTHERS 9)
(def EXITS 10)
(def KYC-DATA 11)

(def SURVEY-DATA 12)
(def PRE-INVESTMENT-CHECKS 13)
(def PRE-EXIT-CHECKS 16)
(def FEE-DATA 20)
(def KPI-DATA 32)

(def TENANT-KYC-DATA 36)
(def TENANT-SCREENING-DATA 40)

(def COUNTERPARTY-DILIGENCE-DATA 41)

(def CONTRACT-KYC-DATA 42)

(def TRANSACTION-PROCESS-DATA 43)

(def COMPLETE 1000)
